// src/components/PromoPopup.jsx

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../api/axiosInstance";
import { FaTimes } from "react-icons/fa";
import { GiLotus } from "react-icons/gi";

const SESSION_KEY = "jb_promo_popup_dismissed_id";

const PromoPopup = () => {
  const [popup, setPopup] = useState(null);
  const [visible, setVisible] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchPopup = async () => {
      try {
        const res = await axios.get("/api/popups/active/");
        console.log("Popup API:", res.data);

        const livePopup = res.data?.popup;
        console.log("Live Popup:", livePopup);

        if (!mounted || !livePopup) return;

        // const dismissedId = sessionStorage.getItem(SESSION_KEY);
        // console.log("Dismissed:", dismissedId);

        // if (String(dismissedId) === String(livePopup.id)) return;

        setPopup(livePopup);
        setTimeout(() => setVisible(true), 600);
      } catch (err) {
        console.error(err);
      }
    };

    fetchPopup();
    return () => {
      mounted = false;
    };
  }, []);

  const handleClose = () => {
    setVisible(false);
    if (popup) sessionStorage.setItem(SESSION_KEY, popup.id);
  };

  if (!popup || !visible) return null;

  const isExternalLink = /^https?:\/\//.test(popup.button_link || "");

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4 py-6"
      role="dialog"
      aria-modal="true"
      onClick={handleClose}
    >
      <div
        className="relative w-full max-w-sm sm:max-w-md bg-[#FDF6EC] rounded-2xl overflow-hidden shadow-2xl ring-1 ring-amber-200 animate-[popupIn_0.35s_ease-out]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          aria-label="Close"
          className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/90 text-[#7B1C1C] hover:bg-white shadow-md transition-colors"
        >
          <FaTimes className="text-sm" />
        </button>

        {/* Image banner */}
        {popup.image && !imageError && (
          <div className="w-full bg-gradient-to-br from-[#7B1C1C] to-[#3D0A0A]">
            <img
              src={popup.image}
              alt={popup.title}
              onError={() => setImageError(true)}
              className="w-full h-40 sm:h-48 object-cover"
            />
          </div>
        )}

        {/* Content */}
        <div className="px-5 sm:px-7 py-5 sm:py-6 text-center">
          <div className="flex justify-center mb-2">
            <GiLotus className="text-amber-500 text-xl" />
          </div>

          <h2
            className="font-bold text-lg sm:text-xl text-[#7B1C1C] leading-snug mb-2"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {popup.title}
          </h2>

          {popup.description && (
            <p className="text-sm sm:text-base text-[#5A4632] leading-relaxed mb-4">
              {popup.description}
            </p>
          )}
          {isExternalLink ? (
            <a
              href={popup.button_link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClose}
              className="inline-block w-full sm:w-auto bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white font-semibold px-8 py-2.5 rounded-full text-sm sm:text-base transition-colors"
            >
              {popup.button_text}
            </a>
          ) : (
            <Link
              to={popup.button_link}
              onClick={handleClose}
              className="inline-block w-full sm:w-auto bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white font-semibold px-8 py-2.5 rounded-full text-sm sm:text-base transition-colors"
            >
              {popup.button_text}
            </Link>
          )}

          {popup.disclaimer && (
            <p className="mt-4 text-[10px] sm:text-xs text-[#8B7355] leading-relaxed">
              {popup.disclaimer}
            </p>
          )}
        </div>
      </div>

      <style>{`
        @keyframes popupIn {
          from { opacity: 0; transform: scale(0.92) translateY(8px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default PromoPopup;
